


import React,{Component} from 'react';

 import {Link} from 'react-router-dom';

 
class orgsLoopComponent extends Component{

 
render()
{
    const {data} = this.props;

    const orgsList = data.map(org =>
        {
            let updateLink = `/gitsearch/updates/${org.recordId}/${org.org_name}/organization`;
            let deleteLink = `/gitsearch/DeleteOrgs/${org.recordId}`;
            let reposViewLink = `/gitsearch/orgs/repos/${org.org_name}`;
            let eventsViewLink = `/gitsearch/orgs/events/${org.org_name}`;

            return(
            <li key={org.recordId}>
          
            <section className="list-left">
            <h5 className="title">Organization: {org.org_name} </h5>
            
            </section>
            <section className="list-right">
            <span className="cityname"><Link to={eventsViewLink}>View Orgs Events</Link></span>
            <span className="cityname"><Link to={reposViewLink}>View Orgs Repos</Link></span>
            <span className="date"><Link to={updateLink}>Update organization details</Link></span>
            <span className="cityname"><Link to={deleteLink}>Delete organization details</Link></span>
            
            </section>
            <div className="clearfix"></div>
            </li> 
            )

        });

return(

            
        <div>
        {orgsList}

        </div>   
           
);

}


}




export default orgsLoopComponent;


